function ProductForm({
  product,
  setProduct,
  price,
  setPrice,
  qty,
  setQty,
  receivedAmount,
  setReceivedAmount,
  addItem,
}) {
  return (
    <div className="card">
      <h3>Add Product</h3>

      <input
        placeholder="Product"
        value={product}
        onChange={(e) => setProduct(e.target.value)}
      />

      <input
        placeholder="Price"
       
        value={price}
        onChange={(e) => setPrice(Number(e.target.value))}
      />

      <input
        placeholder="Qty"
        type="number"
        value={qty}
        onChange={(e) => setQty(Number(e.target.value))}
      />
      <input 
      placeholder="receivedAmount"
     
      value={receivedAmount}
      onChange={(e) => setReceivedAmount(Number(e.target.value))}/>
   
      <button onClick={addItem}>Add Item</button>
    </div>
  );
}

export default ProductForm;